import React from "react";
import {
  Criteria,
  EuiBasicTable,
  EuiFlexGroup,
  EuiFlexItem,
  EuiTableSortingType,
  Pagination,
} from "@elastic/eui";

export interface TablaBasicaProps {
  datos: Array<any>;
  paginador: Ipaginador;
  ordenamiento: Iordenamiento;
  columnas: Array<any>;
  itemId: string;
  itemIdToExpandedRowMap?: Record<string, React.ReactNode>;
}

export type Ipaginador = {
  pagina: number;
  setPagina: (pagina: number) => void;
  rowsPerPage: number;
  total: number;
  setRowsPerPage: (rowsPerPage: number) => void;
};

export type Iordenamiento = {
  sortField: string | number | symbol;
  sortDirection: "asc" | "desc";
  setSortField: (sortField: string | number | symbol) => void;
  setSortDirection: (sortDirection: "asc" | "desc") => void;
};

const TablaBasica = ({
  datos,
  paginador,
  ordenamiento,
  columnas,
  itemId,
  itemIdToExpandedRowMap
}: TablaBasicaProps) => {
  const { pagina, rowsPerPage, setPagina, setRowsPerPage, total } = paginador;
  const { sortField, sortDirection, setSortField, setSortDirection } =
    ordenamiento;

  const pagination: Pagination = {
    pageIndex: pagina,
    pageSize: rowsPerPage,
    totalItemCount: total,
    pageSizeOptions: [3, 5, 8],
    showPerPageOptions: false,
  };

  const sorting: EuiTableSortingType<any> = {
    sort: {
      field: sortField,
      direction: sortDirection,
    },
  };

  const onTableChange = ({ page, sort }: Criteria<any>) => {
    if (page) {
      const { index: pageIndex, size: pageSize } = page;
      setPagina(pageIndex);
      setRowsPerPage(pageSize);
    }
    if (sort) {
      const { field: sortFieldd, direction: sortDirectionn } = sort;
      setSortField(sortFieldd);
      setSortDirection(sortDirectionn);
    }
  };
  return (
    <>
      <EuiFlexGroup alignItems="center">
        <EuiFlexItem />
      </EuiFlexGroup>
      <EuiBasicTable
        tableCaption="Tabla"
        items={datos}
        noItemsMessage="No se encontraron registros"
        itemId={itemId}
        columns={columnas}
        pagination={pagination}
        itemIdToExpandedRowMap={itemIdToExpandedRowMap}
        sorting={sorting}
        onChange={onTableChange}
      />
    </>
  );
};

export default TablaBasica;
